import { ApprovalFlowsPage } from '@hq/sys-admin';
import { hq } from '../session';

/**
 * 审批流（运营端本租户）：流程/节点/条件路由/独立授权。
 * 页面实现收敛在 `@hq/sys-admin`，本端关闭「来源」列（凭令牌自动收口到本租户）。
 */
export default function ApprovalFlows() {
  return <ApprovalFlowsPage hq={hq} />;
}
